import { configureStore, combineReducers } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { authReducer } from './authState/authState';
import { auditLogReducer } from './auditLogState/auditLogState';
import { acceptanceReducer } from './acceptanceState/acceptanceState';
import { connectivityReducer } from './connectivityState/connectivityState';
import { localizationReducer } from './localizationState/localizationState';
import { metaReducer } from './metaState/metaState';
import { layoutReducer } from './layoutState/layoutState';
import { userReducer } from './userState/userState';
import { userGroupReducer } from './userGroupState/userGroupState';
import { userRoleReducer } from './userRoleState/userRoleState';
import { userUpdateReducer } from './userUpdateState/userUpdateState';
import { userPasswordPolicyReducer } from './userPasswordPolicyState/userPasswordPolicyState';
import { softwareReducer } from './softwareState/softwareState';
import { softwareUpdateReducer } from './softwareUpdateState/softwareUpdateState';
import { lwm2mReducer } from './lwm2mState/lwm2mState';
import { husqiotbusReducer } from './husqiotbusState/husqiotbusState';
import { rolloutReducer } from './rolloutState/rolloutState';

const rootReducer = combineReducers({
  auth: authReducer,
  auditLog: auditLogReducer,
  user: userReducer,
  userUpdate: userUpdateReducer,
  userPasswordPolicy: userPasswordPolicyReducer,
  userGroup: userGroupReducer,
  userRole: userRoleReducer,
  acceptance: acceptanceReducer,
  connectivity: connectivityReducer,
  software: softwareReducer,
  softwareUpdate: softwareUpdateReducer,
  rollout: rolloutReducer,
  lwm2m: lwm2mReducer,
  husqiotbus: husqiotbusReducer,
  localization: localizationReducer,
  meta: metaReducer,
  layout: layoutReducer,
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// eslint-disable-next-line no-underscore-dangle
const devTools = (window as any).__REDUX_DEVTOOLS_EXTENSION__;
const isDevEnv = process.env.NODE_ENV === 'development';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const defaultMiddleware = getDefaultMiddleware();
    if (isDevEnv) {
      defaultMiddleware.concat(logger);
    }
    return defaultMiddleware;
  },
  devTools: isDevEnv && devTools && devTools(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
